import { Component, EventEmitter, Input, Output } from '@angular/core';

import { InventoryOptionNotDeleted } from '../../models/inventory-option.model';

@Component({
    selector: 'inventory-grey-select',
    templateUrl: './inventory-grey-select.component.html',
    styleUrls: ['./inventory-grey-select.component.scss'],
})
export class InventoryGreySelectComponent {
    @Input() type: 'checkbox' | 'radio' = 'radio';
    @Input() options: InventoryOptionNotDeleted[] = [{ label: 'Try refreshing', value: '', checked: false }];
    @Input() selectedOption?: string = null;

    @Output() selectionChange = new EventEmitter<string | string[]>();

    updateModelValue(event: any, option: InventoryOptionNotDeleted) {
        if (this.type === 'radio') {
            this.selectedOption = option.value as string;
            this.selectionChange.emit(this.selectedOption);
        } else {
            option.checked = event.target.checked;
            const selectedValues: string[] = this.options.filter((o) => o.checked).map((o) => o.value as string);
            this.selectionChange.emit(selectedValues);
        }
    }
}
